import { enqueueSnackbar, closeSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export const showMessage = (message, variant = 'info', options = {}) => {
    enqueueSnackbar(message, {
        variant,
        ...options,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        },
        action: (key) => (
            <IconButton onClick={() => closeSnackbar(key)} sx={{ color: '#fff' }} size="small">
                <CloseIcon fontSize="small" />
            </IconButton>
        ),
        style: {
            borderRadius: 8,
            // padding: '12px 16px',
            fontWeight: 500,
            fontSize: '0.95rem',
            backgroundColor: variant === 'error'
                ? '#d32f2f'
                : variant === 'success'
                    ? '#2e7d32'
                    : variant === 'warning'
                        ? '#ed6c02'
                        : '#0288d1', // info
            color: '#fff',
            ...options?.style,
        },
    });
};
